/**
 * Extract city and district from Google Geocoder result
 * @param {Object} geocoderResult - Google Geocoder result object (from results[0])
 * @returns {Object} { city: string|null, district: string|null }
 */
export const extractCityDistrict = (geocoderResult) => {
  if (!geocoderResult || !geocoderResult.address_components) {
    return { city: null, district: null };
  }

  const addressComponents = geocoderResult.address_components;
  if (!Array.isArray(addressComponents)) {
    return { city: null, district: null };
  }

  let city = null;
  let district = null;

  // Extract city (priority: locality > administrative_area_level_2 > administrative_area_level_1)
  const cityTypes = ['locality', 'administrative_area_level_2', 'administrative_area_level_1'];
  for (const type of cityTypes) {
    const component = addressComponents.find(
      comp => comp.types && Array.isArray(comp.types) && comp.types.includes(type)
    );
    if (component && component.long_name) {
      city = component.long_name;
      break;
    }
  }

  // Extract district/neighborhood (priority: sublocality_level_1 > neighborhood > sublocality)
  const districtTypes = ['sublocality_level_1', 'neighborhood', 'sublocality'];
  for (const type of districtTypes) {
    const component = addressComponents.find(
      comp => comp.types && Array.isArray(comp.types) && comp.types.includes(type)
    );
    if (component && component.long_name) {
      district = component.long_name;
      break;
    }
  }

  return { city, district };
};
